import {createSlice} from '@reduxjs/toolkit';

// ---- import from local actions ----
import {fetchElevatorSelection, fetchElevatorList} from './../actions/ElevatorActions';

const ElevatorSlice = createSlice({
  name: 'elevator',
  initialState: {
    elevatorSelection: {
      data: [],
      status: 'idle',
      error: '',
      loading: false,
    },
    elevatorList: {
      data: [],
      status: 'idle',
      error: '',
      loading: false,
    },
    caseList: {
      data: [],
      status: 'idle',
      error: '',
      loading: false,
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchElevatorSelection.pending, (state) => {
        state.elevatorSelection.status = 'loading';
      })
      .addCase(fetchElevatorSelection.fulfilled, (state, action) => {
        state.elevatorSelection.status = 'idle';
        state.elevatorSelection.data = action.payload.result;
      })
      .addCase(fetchElevatorSelection.rejected, (state, action) => {
        state.elevatorSelection.status = 'rejected';
        state.elevatorSelection.error = action.error.message;
      })

      .addCase(fetchElevatorList.pending, (state) => {
        state.elevatorList.status = 'loading';
      })
      .addCase(fetchElevatorList.fulfilled, (state, action) => {
        state.elevatorList.status = 'idle';
        state.elevatorList.data = action.payload.result;
      })
      .addCase(fetchElevatorList.rejected, (state, action) => {
        state.elevatorList.status = 'rejected';
        state.elevatorList.error = action.error.message;
      });
  },
});

export default ElevatorSlice.reducer;
